import { useEffect, useRef, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { SelectorDeMes } from './SelectorDeMes';

const MESES_LARGOS = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

/** El `SelectorDeMes` dentro de un campo de formulario: se despliega al pulsarlo. */
export function CampoDeMes({
  valor,
  alCambiar,
  minimo,
  maximo,
  accion = 'Elegir',
  arriba = false,
}: {
  valor: string;
  alCambiar: (periodo: string) => void;
  minimo?: string;
  maximo?: string;
  accion?: string;
  arriba?: boolean;
}) {
  const [abierto, setAbierto] = useState(false);
  const [anio, setAnio] = useState(Number(valor.slice(0, 4)));
  const caja = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!abierto) {
      return;
    }
    function fuera(evento: MouseEvent) {
      if (caja.current && !caja.current.contains(evento.target as Node)) {
        setAbierto(false);
      }
    }
    function tecla(evento: KeyboardEvent) {
      if (evento.key === 'Escape') {
        setAbierto(false);
      }
    }
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', tecla);
    return () => {
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('keydown', tecla);
    };
  }, [abierto]);

  const [anioElegido, mesElegido] = valor.split('-');

  return (
    <div ref={caja} className="relative">
      <button
        type="button"
        onClick={() => {
          setAnio(Number(valor.slice(0, 4)));
          setAbierto(!abierto);
        }}
        aria-expanded={abierto}
        aria-haspopup="dialog"
        className="flex h-9 w-full items-center gap-2 rounded-lg border border-armazon-200 bg-white px-2 text-left text-xs font-semibold uppercase text-armazon-700 transition-colors hover:border-marca-400"
      >
        <CalendarDays className="size-4 text-marca-600" aria-hidden />
        {MESES_LARGOS[Number(mesElegido) - 1]} de {anioElegido}
      </button>

      {abierto && (
        <div
          role="dialog"
          className={`absolute left-0 z-50 w-72 shadow-2xl shadow-armazon-900/10 ${
            arriba ? 'bottom-11' : 'top-11'
          }`}
        >
          <SelectorDeMes
            valor={valor}
            alCambiar={(periodo) => {
              alCambiar(periodo);
              setAbierto(false);
            }}
            anio={anio}
            alCambiarAnio={setAnio}
            accion={accion}
            {...(minimo ? { minimo } : {})}
            {...(maximo ? { maximo } : {})}
          />
        </div>
      )}
    </div>
  );
}
